import React, { PropsWithChildren, ReactElement } from "react";
import styles from "./FareCardFooter.module.scss";
import clsx from "clsx";

export type FareCardFooterProps = {
  ctaButton?: ReactElement;
  withSeparator?: boolean;
  padding?: "default" | "small";
};

export const FareCardFooter: React.FC<
  PropsWithChildren<FareCardFooterProps>
> = ({ children, ctaButton, withSeparator = false, padding = "default" }) => {
  return (
    <footer className={styles.footer}>
      {withSeparator && <hr className={styles.separator} />}
      <div className={clsx(styles.content, {
        [styles.smallPadding]: padding == "small"
      })}>{children}</div>
      {ctaButton && (
        <div className={styles.ctaButtonContainer}>{ctaButton}</div>
      )}
    </footer>
  );
};
